import { baseApi } from '@/store/api/baseApi';
import type {
  CreateEmailTemplatePayload,
  EmailTemplate,
  EmailTemplatesResponse,
  UpdateEmailTemplatePayload,
} from '@/types/emailTemplate';

export const emailTemplatesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailTemplates: builder.query<EmailTemplatesResponse, void>({
      query: () => '/email-templates',
      providesTags: [{ type: 'EmailTemplates', id: 'LIST' }],
    }),
    getEmailTemplate: builder.query<EmailTemplate, string>({
      query: (key) => `/email-templates/${key}`,
      providesTags: (_result, _error, key) => [{ type: 'EmailTemplates', id: key }],
    }),
    createEmailTemplate: builder.mutation<EmailTemplate, CreateEmailTemplatePayload>({
      query: (body) => ({
        url: '/email-templates',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'EmailTemplates', id: 'LIST' }],
    }),
    updateEmailTemplate: builder.mutation<
      EmailTemplate,
      { key: string; body: UpdateEmailTemplatePayload }
    >({
      query: ({ key, body }) => ({
        url: `/email-templates/update/${key}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { key }) => [
        { type: 'EmailTemplates', id: key },
        { type: 'EmailTemplates', id: 'LIST' },
      ],
    }),
    deleteEmailTemplate: builder.mutation<{ message?: string }, string>({
      query: (key) => ({
        url: `/email-templates/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, key) => [
        { type: 'EmailTemplates', id: key },
        { type: 'EmailTemplates', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetEmailTemplatesQuery,
  useGetEmailTemplateQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
} = emailTemplatesApi;
